/* eslint-disable import/prefer-default-export */

import { formatCompactPrice, getCountryConfig } from '../../../constants/countryConfig';
import { FEATURE_KEYS } from '../constants';

export function getFeaturesV21(t, hideSMSinfo, isAuCustomer = false, isGbCustomer = false, smsStartingPrice) {
  const PREFIX = 'comparison-table.features';

  // Get SMS pricing based on customer region, sourced from the centralized country-config
  // (see CBU-21106) instead of a scattered per-country pricing map.
  let countryCode = 'US';

  if (isAuCustomer) {
    countryCode = 'AU';
  } else if (isGbCustomer) {
    countryCode = 'GB';
  }

  const countryConfig = getCountryConfig(countryCode);
  const smsPrice = smsStartingPrice != null ? formatCompactPrice(smsStartingPrice, countryConfig.currency) : null;

  const createLabel = (str) => t(`${PREFIX}.${str}.name`);
  const createTooltipLabel = (str) => t(`${PREFIX}.${str}.toolTipText`);
  const createTooltipLinkText = (str) => t(`${PREFIX}.${str}.toolTipLinkText`);
  const createFullrowLabel = (str) => t(`${PREFIX}.${str}.fullRowText`);

  const createLiteLabel = (str) => {
    if (str === 'sms-marketing-gbb') {
      if (!smsPrice) {
        return '';
      }

      return t(`${PREFIX}.${str}.websiteBuilderText`, { price: smsPrice });
    }

    return t(`${PREFIX}.${str}.websiteBuilderText`);
  };

  const createStandardLabel = (str) => {
    if (str === 'sms-marketing-gbb') {
      if (!smsPrice) {
        return '';
      }

      return t(`${PREFIX}.${str}.emailText`, { price: smsPrice });
    }

    return t(`${PREFIX}.${str}.emailText`);
  };

  const createPremiumLabel = (str) => t(`${PREFIX}.${str}.emailPlusText`);

  const createPlansDetailLabels = (str) => ({
    [FEATURE_KEYS.LITE]: createLiteLabel(str),
    [FEATURE_KEYS.STANDARD]: createStandardLabel(str),
    [FEATURE_KEYS.PREMIUM]: createPremiumLabel(str),
  });

  const filterSMSRowsIfShouldHide = (feature) => !(hideSMSinfo && feature.label === createLabel('sms-marketing-gbb'));

  return [
    {
      label: createLabel('users-gbb'),
      tooltipLabel: createTooltipLabel('users-gbb'),
      plansDetails: createPlansDetailLabels('users-gbb'),
    },
    {
      label: createLabel('monthly-email-sends-gbb'),
      tooltipLabel: createTooltipLabel('monthly-email-sends-gbb'),
      plansDetails: createPlansDetailLabels('monthly-email-sends-gbb'),
    },
    {
      label: createLabel('storage-gbb'),
      tooltipLabel: createTooltipLabel('storage-gbb'),
      plansDetails: createPlansDetailLabels('storage-gbb'),
    },
    {
      label: createLabel('customer-support-gbb'),
      tooltipLabel: createTooltipLabel('customer-support-gbb'),
      fullrowLabel: createFullrowLabel('customer-support-gbb'),
    },
    {
      label: createLabel('sms-marketing-gbb'),
      tooltipLabel: createTooltipLabel('sms-marketing-gbb'),
      plansDetails: createPlansDetailLabels('sms-marketing-gbb'),
    },
    {
      label: createLabel('campaign-builder-gbb'),
      tooltipLabel: createTooltipLabel('campaign-builder-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('ai-content-recommendations-gbb'),
      tooltipLabel: createTooltipLabel('ai-content-recommendations-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('brandkit-gbb'),
      tooltipLabel: createTooltipLabel('brandkit-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('hundreds-of-email-templates-gbb'),
      tooltipLabel: createTooltipLabel('hundreds-of-email-templates-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('social-media-marketing-gbb'),
      tooltipLabel: createTooltipLabel('social-media-marketing-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('event-management-gbb'),
      tooltipLabel: createTooltipLabel('event-management-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('surveys-gbb'),
      tooltipLabel: createTooltipLabel('surveys-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('integrations-gbb'),
      tooltipLabel: createTooltipLabel('integrations-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('landing-pages-and-web-sign-up-forms-gbb'),
      tooltipLabel: createTooltipLabel('landing-pages-and-web-sign-up-forms-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('basic-reach-and-engagement-reporting-gbb'),
      tooltipLabel: createTooltipLabel('basic-reach-and-engagement-reporting-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('marketing-campaign-calendar-gbb'),
      tooltipLabel: createTooltipLabel('marketing-campaign-calendar-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: true,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('automated-welcome-email-gbb'),
      tooltipLabel: createTooltipLabel('automated-welcome-email-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: '1',
        [FEATURE_KEYS.STANDARD]: '3',
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('automation-templates-gbb'),
      tooltipLabel: createTooltipLabel('automation-templates-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('subject-line-a-b-testing-gbb'),
      tooltipLabel: createTooltipLabel('subject-line-a-b-testing-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('email-and-social-media-campaign-scheduling-gbb'),
      tooltipLabel: createTooltipLabel('email-and-social-media-campaign-scheduling-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('resend-email-to-non-openers-gbb'),
      tooltipLabel: createTooltipLabel('resend-email-to-non-openers-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('drilldown-reporting-gbb'),
      tooltipLabel: createTooltipLabel('drilldown-reporting-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('basic-contact-segmentation-gbb'),
      tooltipLabel: createTooltipLabel('basic-contact-segmentation-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('social-media-ads-integration-gbb'),
      tooltipLabel: createTooltipLabel('social-media-ads-integration-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: true,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('google-ads-manager-gbb'),
      tooltipLabel: createTooltipLabel('google-ads-manager-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('google-ads-credit-gbb'),
      tooltipLabel: createTooltipLabel('google-ads-credit-gbb'),
      tooltipLinkText: createTooltipLinkText('google-ads-credit-gbb'),
      tooltipLinkUrl: 'https://www.google.com/ads/coupons/terms/',
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('facebook-lookalike-ad-targeting-gbb'),
      tooltipLabel: createTooltipLabel('facebook-lookalike-ad-targeting-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('retargeting-ads-gbb'),
      tooltipLabel: createTooltipLabel('retargeting-ads-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('dynamic-content-in-email-gbb'),
      tooltipLabel: createTooltipLabel('dynamic-content-in-email-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('custom-automation-paths-gbb'),
      tooltipLabel: createTooltipLabel('custom-automation-paths-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('email-engagement-heat-map-gbb'),
      tooltipLabel: createTooltipLabel('email-engagement-heat-map-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('revenue-reporting-gbb'),
      tooltipLabel: createTooltipLabel('revenue-reporting-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('custom-segmentation-gbb'),
      tooltipLabel: createTooltipLabel('custom-segmentation-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
    {
      label: createLabel('search-engine-optimization-gbb'),
      tooltipLabel: createTooltipLabel('search-engine-optimization-gbb'),
      plansDetails: {
        [FEATURE_KEYS.LITE]: false,
        [FEATURE_KEYS.STANDARD]: false,
        [FEATURE_KEYS.PREMIUM]: true,
      },
    },
  ].filter(filterSMSRowsIfShouldHide);
}
